    import PhotoSwipeLightbox from 'https://unpkg.com/photoswipe/dist/photoswipe-lightbox.esm.js';
    import PhotoSwipe from 'https://unpkg.com/photoswipe/dist/photoswipe.esm.js';
    let galleries = document.querySelectorAll('.product-gallery__item-colors');
    galleries.forEach( gallery => {
        let lightbox = new PhotoSwipeLightbox({
            gallery: '.pswp-gallery',
            children: '.product-gallery__item a',
            pswpModule: PhotoSwipe
        });
        lightbox.init();

        let links = gallery.querySelectorAll('.product-gallery__item a');
        links.forEach( link => {
            link.addEventListener('click', function (evt) {
                evt.preventDefault();
            })
        });
    });
